import {
  fetchResourcesJson,
  propertyUrlApi,
  flyersUrlApi,
  flyerUrlApi,
  flyerStoresUrlApi,
  flyerStoreOpeningHoursUrlApi,
  flyerFlyerGibsUrlApi,
  flyerFlyerGibsProductUrlApi,
  flyerWithCustomLabelUrlApi,
  //--- custom ---
  flyersCustomUrlApi,
} from 'utils/apiUrlUtils';

const RESPONSE_STATES = {
  'OUT_OF_COORDS': 'OUT_OF_COORDS'
}

export const fetchPropertyResource = async () =>
  new Promise((resolve, reject) => {
    const propertyUrl = propertyUrlApi();
    fetchResourcesJson(propertyUrl)
      .then((response) => {
        if (response.data) {
          let resources = {
            property: { ...response.data, fetched: true },
            flyers: { list: {}, fetchedLocation: undefined },
          };
          resolve(resources);
        } else {
          reject(new Error('non-existent property'))
        }
      })
      .catch(error => { reject(error) });
  });

export const fetchFlyersResource = async ({ location, storeCustomLabel, flyerCustomLabel }) =>
  new Promise((resolve, reject) => {
    let flyersUrl;
    if (storeCustomLabel || flyerCustomLabel) {
      flyersUrl = flyersCustomUrlApi(location, storeCustomLabel, flyerCustomLabel);
    } else {
      if (location.lat && location.lng) {
        flyersUrl = flyersUrlApi(location);
      } else {
        reject(new Error('position not found'));
      }
    }

    if (flyersUrl) {
      fetchResourcesJson(flyersUrl)
        .then((response) => {
          if (response.data) {
            resolve(response.data);
          } else {
            resolve({ list: {} })
          }
        })
        .catch((error) => {
          console.error(error)
          resolve({ list: {} })
        });
    }
  });

export const fetchFlyerResource = async ({ flyerId, location, storeCustomLabel, skipRetryCallWithoutPosition = false }) =>
  new Promise((resolve, reject) => {
    let flyerUrl = flyerUrlApi(flyerId, location, storeCustomLabel);

    fetchResourcesJson(flyerUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          if (!skipRetryCallWithoutPosition && response.status === RESPONSE_STATES.OUT_OF_COORDS) {
            resolve(fetchFlyerResource({ flyerId, storeCustomLabel, skipRetryCallWithoutPosition: true }));
          } else {
            reject(new Error('flyer not found'));
          }
        }
      })
      .catch((error) => {
        reject(error);
      });
  });

export const fetchStoresResource = ({ flyerId, location, limit, epochTime, skipRetryCallWithoutPosition = false, storeCustomLabel }) =>
  new Promise((resolve, reject) => {
    const resourceUrl = flyerStoresUrlApi(flyerId, location, limit, epochTime, storeCustomLabel);
    fetchResourcesJson(resourceUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          if (!skipRetryCallWithoutPosition && response.status === RESPONSE_STATES.OUT_OF_COORDS) {
            resolve(fetchStoresResource({ flyerId, limit, epochTime, storeCustomLabel, skipRetryCallWithoutPosition: true }));
          } else {
            resolve([])
          }
        }
      })
      .catch((error) => {
        console.error(error)
        resolve([])
      });
  });

export const fetchStoreOpeningHoursResource = (flyerId, storeId) =>
  new Promise((resolve, reject) => {
    const resourceUrl = flyerStoreOpeningHoursUrlApi(flyerId, storeId);
    fetchResourcesJson(resourceUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      })
      .catch((error) => {
        console.error(error)
        resolve({});
      });
  });

export const fetchFlyerGibsResource = (flyerId) => {
  return new Promise((resolve, reject) => {
    const resourceUrl = flyerFlyerGibsUrlApi(flyerId);
    fetchResourcesJson(resourceUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve([])
        }
      })
      .catch((error) => {
        console.error(error)
        resolve([])
      });
  });
};

export const fetchFlyerGibsProductResource = (flyerId, tag) => {
  return new Promise((resolve, reject) => {
    const resourceUrl = flyerFlyerGibsProductUrlApi(flyerId, tag);
    fetchResourcesJson(resourceUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data)
        } else {
          resolve({})
        }
      })
      .catch((error) => {
        console.error(error)
        resolve({})

      });
  });
};

export const fetchFlyerWithCustomLabelResource = (flyerCustomLabel, customerStoreCode) => {
  return new Promise((resolve, reject) => {
    const resourceUrl = flyerWithCustomLabelUrlApi(flyerCustomLabel, customerStoreCode);
    fetchResourcesJson(resourceUrl)
      .then((response) => {
        if (response.data) {
          resolve(response.data)
        } else {
          reject(new Error('flyer with customer label  not found'))
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
